<template>
    <div class="mb-5">
        <template v-if="states.categoryList.length > 1">
            <TabNav
                v-model="states.current"
                :items="states.categoryList"
                textColorNoneActive="text-blue-1"
                :itemText="itemTextKey"
                :itemValue="itemValueKey"
                scrollable
                paddingX="px-2"
                gap="mx-2"
                fontSize="text-sm"
            ></TabNav>
        </template>
        <template v-else>
            <div class="text-center text-blue-1 text-sm uppercase">
                <template v-if="states.categoryList.length != 0">
                    {{ states.categoryList[0][itemTextKey] }}
                </template>
            </div>
        </template>
    </div>
</template>
<script>
import { watch } from "vue"
import { useRoute, useRouter } from "vue-router"
import useCategoryComposable from "@/composables/Campaigns/CategoryComposable"

import TabNav from "@/components/Tab/TabNav.vue"

// config
import ConfigManager from "@/config/ConfigManager"

import Locale from "@/helper/locale/Locale"

export default {
    name: 'CampaignCategorySpecialForYou',
    components: {
        TabNav
    },
    emits: ["onChangeCategory"],
    computed: {
        itemTextKey: function () {
            if (Locale.getLocaleCode() == 1033) {
                return "nameEn"
            } else {
                return "nameTh"
            }

        },
        itemValueKey: function () {
            return "id"
        },
    },
    setup: function (props, context) {
        const route = useRoute()
        const router = useRouter()
        const { states } = useCategoryComposable(false, ConfigManager.getCategorySpecialForYou())

        const resolveCategoryFromRoute = (list) => {
            if (list.length === 0) {
                return
            }

            if (route.name !== "promotion-special4you") {
                // navigated away from this page already (e.g. SideMenu) —
                // don't sync/replace the route back here
                return
            }

            const categoryId = route.params.categoryId
            if (categoryId) {
                const cat = list.find((x) => x.id == categoryId)
                if (cat) {
                    if (states.current != cat.id) {
                        states.current = cat.id
                    }
                    return
                }

                router.replace({ name: "promotion-special4you" })
                return
            }

            let voucherCat = null
            if (route.query.tab === "history") {
                voucherCat = list.find(
                    (cat) => (cat.detail || "").toLowerCase() === "history"
                )
            }
            const nextId = voucherCat ? voucherCat.id : list[0].id
            if (states.current != nextId) {
                states.current = nextId
            }
        }

        watch(() => {
            return states.current
        }, (val) => {
            if (val != null) {
                context.emit("onChangeCategory", val)
            }
        })

        watch(() => {
            return states.categoryList
        }, (list) => {
            resolveCategoryFromRoute(list)
        })

        watch(() => {
            return route.params.categoryId
        }, () => {
            resolveCategoryFromRoute(states.categoryList)
        })

        return {
            states
        }
    },
    methods:{
        getCateDetail: function(id){
            let cat = this.states.categoryList.find(x => x.id == id);
            return cat;
        }
    }
}
</script>
